import DOMPurify from "dompurify";

// Sanitize any HTML string before it is injected via dangerouslySetInnerHTML.
// Keeps inline styles + SVG (needed by the ad overlay renderers and mini thumbnails)
// while stripping scripts/event handlers.
export function sanitize(html) {
  return DOMPurify.sanitize(String(html == null ? "" : html), {
    USE_PROFILES: { html: true, svg: true, svgFilters: true },
    ADD_ATTR: ["target"],
  });
}
